import { faStar } from '@fortawesome/pro-regular-svg-icons';
import { Box, createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import clsx from 'clsx';
import IconCircle from 'components/UI/IconCircle';
import TitlePrimary from 'components/UI/Title/TitlePrimary';
import DefaultHeader from 'components/UI/V2/DefaultHeader/DefaultHeader';
import { FunctionComponent } from 'react';
import PrimaryButton from 'rocket/components/Buttons/PrimaryButton';

interface MembershipsIsEmptyProps {
    onClick?: () => void;
    titleClassName?: string;
    paragraphClassName?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flex: 1,
            fontSize: 15,
            lineHeight: 1.4,
            display: 'flex',
            textAlign: 'center',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        baseContainer: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        headingTitle: {
            width: '100%',
            fontSize: '20px',
            fontWeight: 600,
            padding: '26px 16px 0'
        },
        icon: {
            margin: '0px auto 15px',
            [theme.breakpoints.down('xs')]: {
                margin: '0px auto 25px'
            }
        },
        title: {
            [theme.breakpoints.down('xs')]: {
                fontSize: 28,
                lineHeight: 1.2,
                fontFamily: 'Poppins',
                fontWeight: 600,
                marginBottom: 0
            }
        },
        paragraph: {
            fontSize: 15,
            lineHeight: 1.4,
            marginBottom: 20,
            [theme.breakpoints.down('xs')]: {
                fontWeight: 400,
                fontSize: 16,
                maxWidth: 300,
                margin: '10px auto 20px'
            }
        },
        button: {
            width: 'auto',
            fontWeight: 500,
            paddingLeft: 35,
            paddingRight: 35,
            margin: '0px auto',
            display: 'inline-block',
            [theme.breakpoints.down('xs')]: {
                fontWeight: 600
            }
        },
        header: {
            position: 'relative'
        }
    })
);

const MembershipsIsEmpty: FunctionComponent<MembershipsIsEmptyProps> = props => {
    const classes = useStyles();

    return (
        <Box className={classes.baseContainer}>
            <DefaultHeader
                title={'Memberships'}
                id="memberships_add_button"
                className={classes.header}
            />
            <Box className={classes.root}>
                <IconCircle
                    icon={faStar}
                    className={classes.icon}
                />
                <TitlePrimary className={clsx(classes.title, props.titleClassName)}>
                    Create a new Membership
                </TitlePrimary>
                <Typography className={clsx(classes.paragraph, props.paragraphClassName)}>
                    Click the “Add Membership” button to add your first one
                </Typography>

                <PrimaryButton
                    label="+ Add Membership"
                    className={classes.button}
                    onClick={props.onClick}
                />
            </Box>
        </Box>
    );
};

export default MembershipsIsEmpty;
